import { Injectable } from '@angular/core';
import { Storage } from '@capacitor/storage';

@Injectable()
export class StorageService {

  async init(): Promise<void> {
    const instance = await Storage.configure({ group: 'ichopin' });
  }

  async getItem<T = string>(key: string): Promise<T> {
    const res = await Storage.get({ key });
    return this.convertFromJSON<T>(res.value);
  }

  async setItem(key: string, data: any): Promise<void> {
    const value = this.convertToString(data);
    await Storage.set({ key, value });
  }

  async removeItem(key: string): Promise<void> {
    await Storage.remove({ key });
  }

  private convertToString(data: any): string {
    switch (typeof data) {
      case 'object':
        return JSON.stringify(data);
      case 'string':
        return data;
      default:
        return data.toString();
    }
  }

  private convertFromJSON<T = string>(data: any): T {
    if (!data || !data[0] || !['{', '['].includes(data[0])) {
      return data;
    }

    return JSON.parse(data);
  }
}
